import * as React from 'react';
import Utils from '../../../../common/utils';

interface Config {
	questionName: string;
	otherName: string;
	otherDetailsName: string;
}
interface Props {	
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	gender?: string;
	nextStep?: (e: any) => void;
	prevStep?: (e: any) => void;
}
function handleNoneOptionAndValidationHOC(WrappedComponent: any, config: Config) {
	return class extends React.Component<Props> {
		onChange = (e: any) => {
			const customEvent = this.createCustomQuestionEvent(e);
			this.props.onQuestionnaireChange(customEvent);
		}
		onBlur = (e: any) => {
			const customEvent = this.createCustomQuestionEvent(e);
			this.props.onQuestionnaireBlur(customEvent);
		}
		createCustomQuestionEvent = (e: any) => {
			const value = Utils.parseValueFromEvent(e);

			let answer = {
				...this.props.questionnaire[config.questionName],
				[e.target.name]: value
			};

			if (e.target.name === `${config.questionName}None` && value) {
				// user clicked none option, remove all other options
				answer = {
					[e.target.name]: value
				};
			} 
			else {
				answer[`${config.questionName}None`] = false;
			}

			this.addValidationToAnswer(answer);
			const questionnaireEvent = {
				target: {
					name: config.questionName,
					value: answer,
					type: 'custom',
				}
			};

			return questionnaireEvent;
		}
		addValidationToAnswer = (answer: any) => {
			// add an isValid prop to the answer

			// if any of the answers in the answer object are true return valid.
			var isValid = Object.keys(answer).some((key) => {
				// if Other is true check if the details have been entered.
				if (key === config.otherName && answer[key]) {
					return answer[config.otherDetailsName];
				}
				else if (key === 'isValid') { // don't check on isValid
					return false;
				}

				return answer[key]; 
			});
			answer.isValid = isValid;

			return answer;
		}

		render() {			
			if (this.props.questionnaire[config.questionName] === undefined) {
				this.props.questionnaire[config.questionName] = {};
			}
			let { onQuestionnaireBlur, onQuestionnaireChange, ...passThroughProps } = this.props;			
			return (
				<WrappedComponent 
					onQuestionnaireBlur={this.onBlur} 
					onQuestionnaireChange={this.onChange} 
					{...passThroughProps}
				/>
			);
		}
	};
}

export default handleNoneOptionAndValidationHOC;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/handleNoneOptionAndValidationHOC.tsx